
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    
    function getTableQueryResponseQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getTableQueryResponseInput (
        schemaName:
            string,
            tableName:
            string,
            columns:
            string[],
            whereClauses:
            DataServiceEntities.IWhereClause[],
            orderBy:
            string,
            isDescending:
            boolean,
            limit:
            number,
            offset:
            number,
            password:
            string
    ): IDataServiceRequest {
      const query = getTableQueryResponseQuery();
      return query.createDataServiceRequestForOperation(
          'GetTableQueryResponse',
          true, 
            DataServiceEntities.TableQueryResponseEntityExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.ITableQueryResponseEntity' },
          {
          schemaName: schemaName,
            tableName: tableName,
            columns: columns,
            whereClauses: whereClauses,
            orderBy: orderBy,
            isDescending: isDescending,
            limit: limit,
            offset: offset,
            password: password
          }
      );
    }

    export function getTableQueryResponseAsync (
        context: IContext, schemaName:
            string,
            tableName:
            string,
            columns:
            string[],
            whereClauses:
            DataServiceEntities.IWhereClause[],
            orderBy:
            string,
            isDescending:
            boolean,
            limit:
            number,
            offset:
            number,
            password:
            string
        ): AsyncResult<DataServiceEntities.ITableQueryResponseEntity> {
        const request = getTableQueryResponseInput(schemaName, tableName, columns, whereClauses, orderBy, isDescending, limit, offset, password);
        return callActionOrExecute<DataServiceEntities.ITableQueryResponseEntity>(request, context.callerContext);
        }
      
    function getPriorityPricesTestQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getPriorityPricesTestInput (
        productIdList:
            string[],
            accountNumber:
            string,
            warehouseId:
            string
    ): IDataServiceRequest {
      const query = getPriorityPricesTestQuery();
      return query.createDataServiceRequestForOperation(
          'GetPriorityPricesTest',
          true, 
            DataServiceEntities.PricingPriorityTestResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPricingPriorityTestResponse' },
          {
          productIdList: productIdList,
            accountNumber: accountNumber,
            warehouseId: warehouseId
          }
      );
    }

    export function getPriorityPricesTestAsync (
        context: IContext, productIdList:
            string[],
            accountNumber:
            string,
            warehouseId:
            string
        ): AsyncResult<DataServiceEntities.IPricingPriorityTestResponse> {
        const request = getPriorityPricesTestInput(productIdList, accountNumber, warehouseId);
        return callActionOrExecute<DataServiceEntities.IPricingPriorityTestResponse>(request, context.callerContext);
        }
      
    function getPriorityPricesQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getPriorityPricesInput (
        cartId:
            string,
            enableDebugging:
            boolean
    ): IDataServiceRequest {
      const query = getPriorityPricesQuery();
      return query.createDataServiceRequestForOperation(
          'GetPriorityPrices',
          false, 
            DataServiceEntities.PricingPriorityResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPricingPriorityResponse' },
          {
          cartId: cartId,
            enableDebugging: enableDebugging
          }
      );
    }

    export function getPriorityPricesAsync (
        context: IContext, cartId:
            string,
            enableDebugging:
            boolean
        ): AsyncResult<DataServiceEntities.IPricingPriorityResponse> {
        const request = getPriorityPricesInput(cartId, enableDebugging);
        return callActionOrExecute<DataServiceEntities.IPricingPriorityResponse>(request, context.callerContext);
        }
      

        // @ts-ignore
        function priceHistoryQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("PriceHistory", "PriceHistory", DataServiceEntities.PriceHistoryExtensionClass, key);
        }

        
    export function createGetPriceHistoryInput(itemId: string, inventDimId: string): IDataServiceRequest {
    const query = priceHistoryQuery();
    return query.createDataServiceRequestForOperation('GetPriceHistory', true, DataServiceEntities.PriceHistoryExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IPriceHistory'}, {ItemId: itemId, InventDimId: inventDimId });
    }

    
    export function getPriceHistoryAsync(context: IContext, itemId: string, inventDimId: string): AsyncResult<DataServiceEntities.IPriceHistory> {
    const request = createGetPriceHistoryInput(itemId, inventDimId);
    return callActionOrExecute<DataServiceEntities.IPriceHistory>(request, context.callerContext);
    }
  

        // @ts-ignore
        function productSearchQuery(webGroupId?: string): DataServiceQuery {
        const key = (webGroupId) ? { WebGroupId: webGroupId } :null;
        return new DataServiceQuery("ProductSearch", "WebGroupHeadersEntity", DataServiceEntities.WebGroupHeadersEntityExtensionClass, key);
        }

        
    export function createGetProductsByIdInput(productIdList: number[]): IDataServiceRequest {
    const query = productSearchQuery();
    return query.createDataServiceRequestForOperation('GetProductsById', true, DataServiceEntities.GetProductsByIdResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetProductsByIdResponse'}, {productIdList: productIdList });
    }

    
    export function getProductsByIdAsync(context: IContext, productIdList: number[]): AsyncResult<DataServiceEntities.IGetProductsByIdResponse> {
    const request = createGetProductsByIdInput(productIdList);
    return callActionOrExecute<DataServiceEntities.IGetProductsByIdResponse>(request, context.callerContext);
    }
  
    export function createGetWebGroupBySearchTermInput(queryResultSettings: IQueryResultSettings, searchTerm: string, top: number, minResult: number, catalogId: string): IDataServiceRequest {
    const query = productSearchQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetWebGroupBySearchTerm', false, DataServiceEntities.WebGroupSearchResultEntityExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IWebGroupSearchResultEntity'}, {searchTerm: searchTerm, top: top, minResult: minResult, catalogId: catalogId });
    }

    
    export function getWebGroupBySearchTermAsync(context: IContext, searchTerm: string, top: number, minResult: number, catalogId: string): AsyncResult<DataServiceEntities.IWebGroupSearchResultEntity[]> {
    const request = createGetWebGroupBySearchTermInput(
      context.queryResultSettings || {}, searchTerm, top, minResult, catalogId);
    return callActionOrExecute<DataServiceEntities.IWebGroupSearchResultEntity[]>(request, context.callerContext);
    }
  
    export function createGetWebGroupsByCategoryInput(queryResultSettings: IQueryResultSettings, categoryId: number, webgroupId: string, catalogId: string): IDataServiceRequest {
    const query = productSearchQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetWebGroupsByCategory', false, DataServiceEntities.WebGroupDataExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IWebGroupData'}, {categoryId: categoryId, webgroupId: webgroupId, catalogId: catalogId });
    }

    
    export function getWebGroupsByCategoryAsync(context: IContext, categoryId: number, webgroupId: string, catalogId: string): AsyncResult<DataServiceEntities.IWebGroupData[]> {
    const request = createGetWebGroupsByCategoryInput(
      context.queryResultSettings || {}, categoryId, webgroupId, catalogId);
    return callActionOrExecute<DataServiceEntities.IWebGroupData[]>(request, context.callerContext);
    }
  
    export function createGetWebGroupFiltersInput(queryResultSettings: IQueryResultSettings, categoryId: number, webgroupId: string, catalogId: string): IDataServiceRequest {
    const query = productSearchQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetWebGroupFilters', false, EntityClasses.ProductRefinerClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.ProductRefiner'}, {categoryId: categoryId, webgroupId: webgroupId, catalogId: catalogId });
    }

    
    export function getWebGroupFiltersAsync(context: IContext, categoryId: number, webgroupId: string, catalogId: string): AsyncResult<Entities.ProductRefiner[]> {
    const request = createGetWebGroupFiltersInput(
      context.queryResultSettings || {}, categoryId, webgroupId, catalogId);
    return callActionOrExecute<Entities.ProductRefiner[]>(request, context.callerContext);
    }
  
    export function createGetWebGroupProductPricesInput(itemId: string): IDataServiceRequest {
    const query = productSearchQuery();
    return query.createDataServiceRequestForOperation('GetWebGroupProductPrices', false, DataServiceEntities.GetWebGroupProductPricesResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetWebGroupProductPricesResponse'}, {itemId: itemId });
    }

    
    export function getWebGroupProductPricesAsync(context: IContext, itemId: string): AsyncResult<DataServiceEntities.IGetWebGroupProductPricesResponse> {
    const request = createGetWebGroupProductPricesInput(itemId);
    return callActionOrExecute<DataServiceEntities.IGetWebGroupProductPricesResponse>(request, context.callerContext);
    }
  
    export function createCheckDataInput(): IDataServiceRequest {
    const query = productSearchQuery();
    return query.createDataServiceRequestForOperation('CheckData', false, DataServiceEntities.CheckDataResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.ICheckDataResponse'}, { });
    }

    
    export function checkDataAsync(context: IContext): AsyncResult<DataServiceEntities.ICheckDataResponse> {
    const request = createCheckDataInput();
    return callActionOrExecute<DataServiceEntities.ICheckDataResponse>(request, context.callerContext);
    }
  

        // @ts-ignore
        function orderAttributeQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("OrderAttribute", "OrderAttributeEntity", DataServiceEntities.OrderAttributeEntityExtensionClass, key);
        }

        
    export function createGetOrderAttributesInput(queryResultSettings: IQueryResultSettings, orderId: string): IDataServiceRequest {
    const query = orderAttributeQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetOrderAttributes', false, DataServiceEntities.OrderAttributeExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IOrderAttribute'}, {OrderId: orderId });
    }

    
    export function getOrderAttributesAsync(context: IContext, orderId: string): AsyncResult<DataServiceEntities.IOrderAttribute[]> {
    const request = createGetOrderAttributesInput(
      context.queryResultSettings || {}, orderId);
    return callActionOrExecute<DataServiceEntities.IOrderAttribute[]>(request, context.callerContext);
    }
  